import { LinkableEntityType as ApiLinkableEntityType } from 'src/api/generated/touring/types';
import { LinkableEntityType } from '../../types';

export const mapLinkableEntityType = (
  apiType: ApiLinkableEntityType
): LinkableEntityType => {
  return {
    id: apiType.id,
    name: apiType.name,
    type: apiType.type,
  };
};
